export enum SupportTicketStatus {
  Open = 'open',
  Closed = 'closed',
}

export interface SupportTicketShop {
  id: number;
  uid: string;
  name: string;
}

export interface SupportTicketOrganization {
  id: number;
  name: string;
}

export interface SupportTicketOperator {
  id: number;
  name: string;
}

export interface SupportTicket {
  id: number;
  uid: string;
  title: string;
  status: SupportTicketStatus;
  created: number;
  updated: number;
  last_seen?: number | null;
  organization?: SupportTicketOrganization;
  shop?: SupportTicketShop;
  operator?: SupportTicketOperator;
  messages?: SupportMessage[];
}

export interface SupportMessage {
  id: number;
  ticket_id: number;
  operator_id: number;
  body: string;
  image_urls: string[] | null;
  created: number;
  operator?: SupportTicketOperator;
}

export interface SupportTicketListResponse extends PaginatedResponse<SupportTicket> {}

export interface SupportTicketResponse extends BaseResponse<SupportTicket> {}

export interface SupportMessageResponse extends BaseResponse<SupportMessage> {}
